import React from 'react';
import { LayoutGrid, List } from 'lucide-react';

interface ViewToggleProps {
  view: 'grid' | 'list';
  onViewChange: (view: 'grid' | 'list') => void;
}

export function ViewToggle({ view, onViewChange }: ViewToggleProps) {
  return (
    <div className="flex space-x-2">
      <button
        onClick={() => onViewChange('grid')}
        className={`p-2 rounded-md ${
          view === 'grid' ? 'bg-gray-200' : 'hover:bg-gray-100'
        }`}
        title="Vue grille"
      >
        <LayoutGrid className="w-5 h-5" />
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={`p-2 rounded-md ${
          view === 'list' ? 'bg-gray-200' : 'hover:bg-gray-100'
        }`}
        title="Vue liste"
      >
        <List className="w-5 h-5" />
      </button>
    </div>
  );
}